import React from 'react';
import { Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import Login from './containers/Login';
import Home from './containers/Home';
import Checks from "./containers/Checks";
import UniqueUsers from "./containers/UniqueUsers";
import MobileVerifications from "./containers/MobileVerifications";
import ICVerifications from "./containers/ICVerifications";
import CheckVerifications from "./containers/CheckVerifications";
import PrintPage from "./containers/PrintPage";
import SingleCheck from "./containers/SingleCheck";
import SingleProfile from "./containers/SingleProfile";
import Leads from "./containers/Leads";
import SuspiciousUser from "./containers/SuspiciousUser";
import NotFound from './containers/NotFound';

import RouteApplied from './components/RouteApplied';
import RouteAuthenticated from './components/RouteAuthenticated';

const Routes = ({ childProps }) =>(
  <Switch>
    <RouteApplied path="/" exact component={Login} props={childProps} />
    <RouteAuthenticated path="/home" exact component={Home} props={childProps} />
    <RouteAuthenticated path="/checks" exact component={Checks} props={childProps} />
    <RouteAuthenticated path="/unique-users" exact component={UniqueUsers} props={childProps} />
    <RouteAuthenticated path="/mobile-verifications" exact component={MobileVerifications} props={childProps} />
    <RouteAuthenticated path="/ic-verifications" exact component={ICVerifications} props={childProps} />
    <RouteAuthenticated path="/check-verifications" exact component={CheckVerifications} props={childProps} />
    <RouteAuthenticated path="/print" component={PrintPage} props={childProps} />
    <RouteAuthenticated path='/check/:id' component={SingleCheck} props={childProps} />
    <RouteAuthenticated path='/user/:id' component={SingleProfile} props={childProps} />
    <RouteAuthenticated path="/leads" component={Leads} props={childProps} />
    <RouteAuthenticated path="/suspicious-users" component={SuspiciousUser} props={childProps} />
    <RouteApplied component={NotFound} />
  </Switch>
);

Routes.propTypes = {
  childProps: PropTypes.object,
};

Routes.defaultProps = {
  childProps: null,
};

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.jsx